import React from "react";

import type { CallToActionBlock as CTABlockProps } from "@/payload-types";

export const CallToActionBlock: React.FC<CTABlockProps> = () => {
  return null;
};
